import React from 'react';
import { useSelector } from 'react-redux';
import { Icon, Typography } from '@saviynt/design-system';

import './Header.css';

/**
 * Header component for Copilot - matches Copilot1 design
 */
function Header() {
  const isOnEditMode = useSelector(
    (state: {
      copilot: {
        ui: { endpointKey?: string };
      };
    }) => state.copilot.ui.endpointKey
  );

  return (
    <div className='Copilot-Header'>
      <Icon kind='SaviCompanion' size='large' color='purple-700' />
      <Typography color='--color-neutral-000'>
        {isOnEditMode ? 'Configuration' : 'Setting up Integration Agent'}
      </Typography>
    </div>
  );
}

export default Header;
